export default "__VITE_ASSET__Cj$h_0T9__"